import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

export function shippingAddressValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value : '';

    if (!value) {
      return null;
    }

    if (!REGEX.shippingAddressAndState.test(value)) {
      return { invalidShippingAddress: true };
    }

    return null;
  };
}
